module.exports = __webpack_public_path__ + "static/momentum-100cf62c8853f402051564560eb4b351.jpg";